import { Subscribable } from '@volkswagen-onehub/feature-hub-utils';
export * from './types';
export class LayerManagerV1Impl extends Subscribable {
    constructor(manager) {
        super();
        this.manager = manager;
    }
    openAlert(render, state, options) {
        return this.manager.openAlert(render, state, options);
    }
    openFocusLayer(render, state, options) {
        return this.manager.openFocusLayer(render, state, Object.assign(Object.assign({}, options), { size: "A" /* A */ }));
    }
    openInteractionLayer(render, state, options) {
        return this.manager.openInteractionLayer(render, state, Object.assign(Object.assign({}, options), { size: "A" /* A */ }));
    }
    openContentLayer(render, state, options) {
        // tslint:disable-next-line: deprecation
        return this.manager.openContentLayer(render, state, options);
    }
    getLayers() {
        return this.manager.getLayers();
    }
    subscribe(listener) {
        return this.manager.subscribe(listener);
    }
}
//# sourceMappingURL=index.js.map